import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useWindowSize } from '../../util/hooks'
import PropTypes from 'prop-types'

const DarkLogo = ({ menuOpen, lightLogo, darkLogo }) => {
  const { width } = useWindowSize()

  if (width < 1200 && menuOpen) {
    return <GatsbyImage image={lightLogo.gatsbyImageData} alt="Blok" />
  }

  if (darkLogo.svg) {
    return <div dangerouslySetInnerHTML={{ __html: darkLogo.svg.content }} />
  }

  return <GatsbyImage image={darkLogo.gatsbyImageData} alt="Blok" />
}

const Logo = ({ navConfig, blackLogo, lightLogo, menuOpen }) => {
  const displayDarkLogo =
    (navConfig.isTransparent && navConfig.textColor === 'blue') ||
    !navConfig.isTransparent
  const displayLightLogo =
    navConfig.isTransparent && navConfig.textColor !== 'blue'
  const darkLogo = navConfig.customLogo ?? blackLogo

  if (displayLightLogo) {
    return <GatsbyImage image={lightLogo.gatsbyImageData} alt="Blok" />
  }

  if (displayDarkLogo) {
    return (
      <DarkLogo menuOpen={menuOpen} lightLogo={lightLogo} darkLogo={darkLogo} />
    )
  }

  return null
}

Logo.propTypes = {
  navConfig: PropTypes.object.isRequired,
  blackLogo: PropTypes.object.isRequired,
  lightLogo: PropTypes.object.isRequired,
  menuOpen: PropTypes.bool,
}

export default Logo
